import { useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./quil.scss";
function SummerNoteEditor({ initialContent, onChange = () => {} }) {
  const [content, setContent] = useState(initialContent);
  const quillRef = useRef(null); // Ref to attach to the Quill editor
  const observerRef = useRef(null); // Ref to store the observer

  // Handles changes in the editor and updates state
  const handleChange = (editorContent) => {
    setContent(editorContent);
    onChange(editorContent);
  };

  const modules = {
    toolbar: {
      container: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
    },
  };

  return (
    <div className="note-wrapper gap-2">
      <p style={{ marginBottom: "8px" }} className="input-label mb-4">
        Article content{" "}
      </p>

      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={content}
        onChange={handleChange}
        modules={modules}
      />
    </div>
  );
}

export default SummerNoteEditor;
